import { Box } from '@factorialco/deprecated-design-system'

import { useAtsContext } from 'modules/ats/lib/atsContext'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import DataRetentionSettings from './DataRetentionSettings'
import OpenApplicationSettings from './OpenApplicationSettings'
import TalentPoolSettings from './TalentPoolSettings'

const CandidateDataPage = () => {
  const { atsCompanyId, talentPoolByDefault, canManageAtsSettings } = useAtsContext()
  return (
    <ResponsivePage.Body authorized={canManageAtsSettings} showHeader={false}>
      <Box gap="s48">
        <Box gap="s24">
          <TalentPoolSettings
            atsCompanyId={atsCompanyId}
            talentPoolByDefault={talentPoolByDefault}
          />
          <OpenApplicationSettings />
          <DataRetentionSettings />
        </Box>
      </Box>
    </ResponsivePage.Body>
  )
}

export default CandidateDataPage
